import { Component, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-news-email-subscription',
  standalone: true,
    imports: [
        NgIf
    ],
  templateUrl: './news-email-subscription.component.html',
  styleUrl: './news-email-subscription.component.scss'
})
export class NewsEmailSubscriptionComponent implements OnInit {
  subscriptionForm: FormGroup = new FormGroup({});
  private unsubscribe$ = new Subject();

  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.subscriptionForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      pointOfContact: ['email'],
      topics: [],
    });

    this.subscriptionForm.valueChanges.pipe(takeUntil(this.unsubscribe$),).subscribe();
  }
}
